import PasswordValidate from '@/components/password-validate/password-validate';
import { isEmptyValue } from '@/utils/utils';
import { Vue, Component, Prop, Inject } from 'vue-property-decorator';

@Component({
    name: 'sso-credentials',
    components: {
        'password-validate': PasswordValidate,
    },
})

export default class SSOCredentials extends Vue {
    @Inject('validator') public $validator: any;

    @Prop()
    private validatorCheck: any;

    @Prop({default: false})
    private isSubmitted: any;

    @Prop({default: {}})
    private ssoDetails: any;

    private ssoFields: any = {
        default_password: {
            name: 'Default Password',
            field: 'password-validate',
            modelKey: 'default_password',
            modelValue: '',
            validate: { required: true },
            eventBind: {},
            isValidation: false,
        },
        roster_enable_force_password_change: {
            name: 'Force User to Change Password',
            field: 'b-form-checkbox',
            modelKey: 'roster_enable_force_password_change',
            modelValue: false,
            eventBind: {},
            propBind: {
                switch: true,
            },
            isValidation: false,
        },
    };

    private created() {
        this.ssoDetails.credential = {};
    }

    private inputValidation(item: any) {
        let value = false;
        item.isValidation = true;
        if (this.isSubmitted && item.validate && item.validate.required &&
            isEmptyValue(this.ssoDetails.credential[item.modelKey])) {
            item.isValidation = true;
            value = true;
        }
        return value;
    }

    private inputValidator(errors: any, keyName: string) {
        return this.isSubmitted && errors.has(keyName);
    }
}
